import shortid from "shortid"
import Objdict from "objdict"
import skills from "@frog/source/data/skills.js"
import units from "@frog/source/data/units.js"
import isString from "@frog/source/utility/isString.js"

import Step from "@frog/source/models/Step.js"
import Stage from "@frog/source/models/Stage.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import Navigation from "@frog/source/models/admin/Navigation.js"
import App from "@frog/source/models/App.js"
import Game from "@frog/source/models/Game.js"
import Director from "@frog/source/juice/Director.js"
import Zone from "@frog/source/models/Zone.js"
import Geometry from "@frog/source/utility/Geometry.js"
import InkDialogue from "@frog/source/utility/integration/InkDialogue.js"

export function Ink(inkKey) {
    return function(stage) {
        return InkDialogue(inkKey, stage)
    }
}

export function RespawnDeadUnits({encounterKey, protounits}) {
    return function(stage) {
        const units = Object.values(stage.units).filter((unit) => {
            return Zone.isInBounds(stage.encounters[encounterKey].zone, unit.position)
                && unit.affiliation == "bad"
        })

        return {
            "deltastages": [
                units.map((unit, index) => {
                    return {
                        "unit": {
                            "key": unit.key,
                            "isDead": false,
                            "maxhealth": unit.maxhealth + 5,
                            "health": unit.maxhealth + 5,
                            "position": {
                                "x": protounits[unit.key].position.x,
                                "y": protounits[unit.key].position.y,
                            }
                        }
                    }
                })
            ]
        }
    }
}

export function SlowDeath() {
    return function(stage) {
        const dyingUnits = Object.values(stage.units).filter((unit) => {
            return unit.deathTimer !== undefined
                && unit.isDead != true
        })

        const steps = []
        dyingUnits.map((unit) => {
            if(unit.deathTimer > 1) {
                steps.push({
                    "deltastages": [
                        {
                            "unit": {
                                "key": unit.key,
                                "deathTimer": unit.deathTimer - 1,
                            },
                        },
                        {
                            "func": () => {
                                console.log(unit.deathTimer)
                            }
                        }
                    ]
                })
            } else {
                const SHUDDER = 0.1

                steps.push({
                    "type": "invoke skill",
                    "deltastages": Random.shuffle([
                        {"x": 0, "y": -SHUDDER},
                        {"x": 0, "y": SHUDDER},
                        {"x": SHUDDER, "y": 0},
                        {"x": -SHUDDER, "y": 0},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                        {"x": 0, "y": -SHUDDER},
                        {"x": 0, "y": SHUDDER},
                        {"x": SHUDDER, "y": 0},
                        {"x": -SHUDDER, "y": 0},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                        {"x": SHUDDER, "y": -SHUDDER},
                        {"x": -SHUDDER, "y": SHUDDER},
                    ]).map((deltaposition, index) => {
                        return {
                            "mark": index * 25,
                            "unit": {
                                "key": unit.key,
                                "position": Geometry.add(unit.position, deltaposition)
                            }
                        }
                    })
                })
                if(unit.dialogue["slowdeath"] != undefined) {
                    if(unit.dialogue["slowdeath"] instanceof Array == false) {
                        unit.dialogue["slowdeath"] = new Array(unit.dialogue["slowdeath"])
                    }
                }
                // TODO: unify dialogue plotscript.
                unit.dialogue["slowdeath"].forEach((line) => {
                    steps.push({
                        "type": "StartDialogue",
                        "isImportant": true,
                        "duration": Infinity,
                        "deltastages": [
                            {
                                "mark": 0,
                                "dialogue": {
                                    "text": line,
                                    "data": {
                                        "unitKey": unit.key,
                                    }
                                }
                            }
                        ]
                    })
                })
                steps.push({
                    "type": "FinishDialogue",
                    "deltastages": [
                        {
                            "mark": 0,
                            "dialogue": undefined
                        }
                    ]
                })

                steps.push({
                    "type": "invoke skill",
                    "deltastages": [
                        // TODO: Call a similiar thing in Reactions.js
                        {
                            "mark": 500,
                            "audio": {"triggerKey": "Unit:Death"},
                        },
                        {
                            "mark": 500,
                            "func": () => Audiomix.kill({"label": "music"})
                        },
                        {
                            "mark": 500,
                            "unit": {"key": unit.key, "opacity": 1}
                        },
                        {
                            "mark": 1500,
                            "unit": {"key": unit.key, "opacity": 0}
                        },
                        {
                            "mark": 2500,
                            "unit": {"key": unit.key, "isDead": true}
                        },
                    ]
                })
            }
        })
        return steps
    }
}

export function UpdatePlayerPartyScript() {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounter]

        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == "good"
        })

        alliedUnits.forEach((unit) => {
            App.game.player.party.units[unit.key].isRecruited = true
            if(unit.isDead == true) {
                App.game.player.party.units[unit.key].isDead = true
            }
        })
    }
}

export function SpawnPlayerPartyScript() {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounter]

        const partyUnits = Object.values(stage.player.party.units).filter((unit) => {
            return stage.units[unit.key] == undefined
                && unit.isRecruited == true
                && unit.isDead != true
        })

        const spawnSpots = Object.values(stage.units).filter((unit) => {
            return unit.type == "zone"
                && Zone.isInBounds(currentEncounter, unit.position)
        })

        return {
            "deltastages": [
                spawnSpots.map((spot, index) => {
                    let unit = partyUnits[index]
                    if(unit == undefined) return
                    unit = Objdict.merge(unit, {"position": spot.position})
                    unit.spawnspot = spot
                    return {
                        "unit": unit
                    }
                })
            ]
        }
    }
}

export function HealPlayerPartyScript({percent} = {}) {
    percent = percent || 0.5
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounter]
        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == "good"
                && unit.isDead == false
                && Zone.isInBounds(currentEncounter, unit.position)
        })

        return [
            {
                "name": "HealUnits",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        return {
                            "unit": {
                                "key": unit.key,
                                "isDead": false,
                                "health": Math.min(unit.maxhealth, unit.health + (unit.maxhealth * percent)),
                            }
                        }
                    }),
                ]
            },
        ]
    }
}

function Dialogue(dialogue) {
    dialogue.tags = dialogue.tags || {}
    dialogue.data = dialogue.data || {"unitKey": dialogue.unitKey || dialogue.class}
    return [
        {
            "type": "StartDialogue",
            "isImportant": true,
            "duration": Infinity,
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": dialogue
                }
            ]
        },
        {
            "type": "FinishDialogue",
            "deltastages": [
                {
                    "mark": 0,
                    "dialogue": undefined
                }
            ]
        }
    ]
}

function MoveUnit({unitKey, position}) {
    return {
        "name": "MoveUnit",
        "deltastages": [
            {"unit": {"key": unitKey, "position": position}},
        ]
    }
}

function MoveEncounterScript({nextEncounterKey, spawnTag} = {}) {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounter]
        const nextEncounter = stage.encounters[nextEncounterKey]

        const alliedUnits = Object.values(stage.units).filter((unit) => {
            return unit.affiliation == "good"
                // && unit.isDead == false
                && Zone.isInBounds(currentEncounter, unit.position)
        })

        const spawnZones = Object.values(stage.units).filter((unit) => {
            return unit.type == "zone"
                && (unit.tag == spawnTag || spawnTag == undefined)
                && Zone.isInBounds(nextEncounter, unit.position)
        })

        return [
            {
                "name": "MoveUnits",
                "deltastages": [
                    alliedUnits.map((unit, index) => {
                        const spawnZone = spawnZones[index]
                        if(spawnZone == undefined) return undefined
                        return {"unit": {"key": unit.key, "position": spawnZone.position, "hasBeenRemoved": false}}
                    }),
                ]
            },
            {
                "func": (stage) => {
                    stage.encounters[nextEncounterKey].hasBeenSeen = true
                    stage.encounters[stage.currentEncounter].hasBeenSeen = true
                }
            },
            {
                "name": "JumpToDifferentChapterEncounter",
                "duration": 1000,
                "deltastages": [
                    {"currentEncounter": nextEncounterKey},
                    {"turn": {"number": 0}}
                ]
            },
        ]
    }
}

function EscapeScript({zoneTag} = {}) {
    return function(stage) {
        const currentEncounter = stage.encounters[stage.currentEncounter]

        const zones = Object.values(stage.units).filter((unit) => {
            return unit.type == "zone"
                && (unit.tag == zoneTag || zoneTag == undefined)
                && Zone.isInBounds(currentEncounter, unit.position)
        })

        const escapingUnits = Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.hasBeenRemoved != true
                && unit.affiliation == "good"
                && Zone.isInBounds(currentEncounter, unit.position)
                && zones.find((zone) => zone.position.x == unit.position.x && zone.position.y == unit.position.y)
        })

        return [
            {
                "name": "ExitUnits",
                "deltastages": [
                    escapingUnits.map((unit, index) => {
                        return {
                            "unit": {
                                "key": unit.key,
                                "hasBeenRemoved": true
                            }
                        }
                    }),
                ]
            },
        ]
    }
}

function SpawnUnitsScript({zoneTag, unit, count} = {}) {
    return function(stage) {
        const zones = Object.values(stage.units).filter((unit) => {
            return unit.type == "zone"
                && unit.tag == zoneTag
                // && Zone.isInBounds(currentEncounter, unit.position)
        })

        return [
            {
                "name": "SpawnUnits",
                "deltastages": [
                    zones.map((zone, index) => {
                        if(count !== undefined
                        && count > 0) {
                            return
                        }

                        const collision = Stage.findUnitByPosition(stage, zone.position)
                        if(collision != undefined) return

                        count -= 1

                        return {
                            "unit": { // THIS IS ALL HARDCODED!
                                "key": shortid.generate(),
                                "jobKey": Random.element(["spear", "hammer", "sword"]),
                                "position": zone.position,
                                "affiliation": "bad",
                            }
                        }
                    }),
                ]
            },
        ]
    }
}

// This replaces the old "defeat-all-units-of-affiliation" condition type.
// Returns true if all units of a given affiliation have been defeated.
function DefeatAllUnitsOfAffiliation({stage, affiliation, encounterKey}) {
    if(stage == undefined) return false
    if(affiliation == undefined) return false
    if(encounterKey != undefined
    && encounterKey != stage.currentEncounter) {
        return false
    }
    const remainingUnits = Object.values(stage.units).filter((unit) => {
        if(encounterKey != undefined) {
            const currentEncounter = stage.encounters[encounterKey]
            if(Zone.isInBounds(currentEncounter.zone, unit.position) == false) {
                return false
            }
        }
        if(unit.affiliation != affiliation) return false
        if(unit.isDead) return false
        if(unit.hasBeenRemoved) return false
        return true
    })
    return remainingUnits.length == 0
}

export { Dialogue, MoveUnit, MoveEncounterScript, EscapeScript, SpawnUnitsScript, DefeatAllUnitsOfAffiliation }
